export const isIosApp = (userAgent: string) => {
  const IOS_APP_USER_AGENT_MARKER = /MobileAppVersion/i;

  return IOS_APP_USER_AGENT_MARKER.test(userAgent);
};
